<section class="partner-connect-section" *ngIf="connections.length > 0 || hasError">
    <h2 class="section-title">{{ 'aumico_partner_connect_section_title' | i18next }}</h2>
    <p class="section-description">{{ 'aumico_partner_connect_section_description' | i18next }}</p>

    <p class="section-error" *ngIf="hasError" data-testid="partner-connect-error">
        {{ 'aumico_outbound_api_error_generic' | i18next }}
    </p>

    <div class="cards-grid">
        <aumico-vendor-integration-card
            *ngFor="let connection of connections; trackBy: trackByClientId"
            [vendor]="cardView(connection)"
            [connected]="connection.connected"
            (infoClick)="onInfo(connection)"
        ></aumico-vendor-integration-card>
    </div>
</section>

<aumico-partner-connect-modal
    *ngIf="activeConnection != null"
    [connection]="activeConnection"
    [loginHint]="loginHint"
    (closed)="onModalClosed()"
    (disconnected)="onDisconnected()"
></aumico-partner-connect-modal>
